export default {
  data() {
    return {
      loading: {},
    }
  },
  computed: {
    isLoading() {
      return Object.keys(this.loading).some(key => this.loading[key])
    },
  },
}
